const INSTRUCTION_COUNT = 117;

import { isEmpty } from "lodash";
import Records from "@/services/records";
import RECORDS from "@/constants/records";
import EXTENSIONS from "@/constants/extensions";

export default {
    data() {
        return {
            vetsourceSynced: false,
            vetsourceSyncAlertMessage: RECORDS.ALERT_MESSAGE.VETSOURCE_SYNC_INPROGRESS
        };
    },
    computed: {
        displaySyncAlert() {
            return !this.vetsourceSynced && this.searchOnlinePharmacyOnly;
        },
        displayClientAlert() {
            return (
                (!this.hasClientEmailAddress || !this.hasClientPhoneNumber) &&
                this.hasPatientPrimaryOwner &&
                this.vetsourceSynced &&
                this.searchOnlinePharmacyOnly
            );
        },
        displayPatientAlert() {
            return (
                (!this.hasPatientPrimaryOwner || !this.hasPatientWeight) &&
                this.vetsourceSynced &&
                this.searchOnlinePharmacyOnly
            );
        },
        disableSubmitNewRecommendation() {
            if (
                this.searchOnlinePharmacyOnly &&
                (!this.vetsourceSynced ||
                    !this.hasPatientPrimaryOwner ||
                    !this.hasClientEmailAddress ||
                    !this.hasClientPhoneNumber ||
                    !this.hasPatientWeight)
            ) {
                return true;
            }

            return false;
        },
        patientAlertMessage() {
            let message = "A Home Delivery recommendation cannot be made because this patient does not have";
            let props = { 
                name: "patient_profile",
                query: { tabName: "tabRelationships" },
                params: { id: this.patient_encoded_id }
            };

            if (!this.hasPatientPrimaryOwner) {
                message += " an owner for shipping purposes";
            }

            if (!this.hasPatientPrimaryOwner && !this.hasPatientWeight) {
                message += " and";
            }

            if (!this.hasPatientWeight) {
                message += " weight information";
            }

            if (!this.hasPatientWeight && this.hasPatientPrimaryOwner) {
                props.query = { modal: "VITAL", modalField: "Weight" };
            }

            let link = this.$router.resolve(props);

            message += `. Please click <a target="_blank" href="${link.href}">here</a>`;

            if (!this.hasPatientPrimaryOwner && !this.hasPatientWeight) {
                message += ` to update and try again.`;
            } else if (!this.hasPatientWeight) {
                message += ` to update the patient and try again.`;
            } else if (!this.hasPatientPrimaryOwner) {
                message += ` to create the client and try again.`;
            }

            return message;
        },
        ownerAlertMessage() {
            let message = "";

            if (!this.hasClientEmailAddress) {
                message += "an email address";
            }

            if (!this.hasClientEmailAddress && !this.hasClientPhoneNumber) {
                message += " and";
            }

            if (!this.hasClientPhoneNumber) {
                message += " phone number";
            }

            return message;
        },
        vetsourceEnabled() {
            return this._isExtensionEnabled(EXTENSIONS.CODE.CODE_VETSOURCE);
        },
    },
    watch: {
        searchOnlinePharmacyOnly(value, oldValue) {
            if (value) {
                this.title = "New Recommendation";
                this.instructionCount = INSTRUCTION_COUNT;
                this.syncRecord();
            } else {
                this.title = "New Record";
                this.instructionCount = 200;
            }

            this.$refs["select-item"].focus();

            // reset fields related to new recommendation
            this.data.staff_id = null;
            this.data.given_by = null;
            this.data.item = null;
            this.data.item_name = "";
            this.data.quantity = 1;
            this.data.instruction = "";
            this.data.record_note = "";
            this.data.refill = 0;
            this.data.next_due = "";
            this.data.soap = -1;

            this.getStaffList();
        }
    },
    created() {
        // Load the initial wvalue from localStorage
        // by default is true since backend socket that update the value only run twice
        // during vetsource add on enabled and finished syncing 
        this.vetsourceSynced =
            localStorage.getItem("vetsource_synced") === "true";

        // Listen for changes in localStorage
        window.addEventListener("storage", this.updateVetsourceSync);
    },
    beforeDestroy() {
        window.removeEventListener("storage", this.updateVetsourceSync);
    },
    mounted() {
        if (this.vetsourceEnabled) {
            this.getSyncStatus();
        }
    },
    methods: {
        async saveRecommendation() {
            let dueDate = this.data.expire ? new Date(this.data.expire) : null;

            let params = {
                patient_id: this.params.patient.id,
                provider_id: this.data.staff_id.id,
                given_by_id: this.data.given_by ? this.data.given_by.id : null,
                item: this.data.item.id,
                item_name: this.data.item.name,
                quantity: this.data.quantity,
                uom: this.data.uom,
                expire: dueDate ? Math.floor(dueDate / 1000) : null,
                instruction: this.data.instruction
                    ? this.data.instruction
                    : null,
                note: null,
                record_note: this.data.record_note
                    ? this.data.record_note
                    : null,
                personal_note: this.data.personal_note
                    ? this.data.personal_note
                    : null,
                refill: this.data.refill ? this.data.refill : 0
            };

            let recommendationUrl = "record/recommendation";

            let res = await this.$http.post(
                process.env.BARRAMUNDI + recommendationUrl,
                params
            );

            let response = res.data.response;

            if (response && response.messages && response.code === 200) {
                this._message(response.message, "success");
                this.loading = false;
                this.$emit("onSuccess");
                this.$refs.createUpdateRecord.hide();
            } else {
                this.loading = false;
                this._message(response.messages, "danger");
            }
        },
        updateRecommendationData(e) {
            this.data.quantity = e.quantity;
            this.data.record_note = e.record_note;
            this.data.instruction = e.instruction;
            this.data.personal_note = e.personal_note;
            this.data.staff_id = e.staff_id;
            this.data.given_by = e.given_by;
            this.data.given_date = e.given_date;
            this.data.next_due = e.next_due;
            this.data.soap = e.soap;
            this.data.refill = e.refill;
            this.data.expire = e.expire;
            this.data.soap = e.soap;
        },
        updateVetsourceSync() {
            this.vetsourceSynced =
                localStorage.getItem("vetsource_synced") === "true";
        },
        verifyPatientParams(patient) {
            if (patient.weight) {
                this.hasPatientWeight = true;
            }

            if (patient.primaryOwner) {
                this.hasPatientPrimaryOwner = patient.primaryOwner.length > 0;

                if (this.hasPatientPrimaryOwner) {
                    // check the first in the primaryOwner array since there can only be one primary owner for a patient
                    this.hasClientEmailAddress = !isEmpty(
                        patient.primaryOwner[0].email
                    );
                    this.hasClientPhoneNumber = !isEmpty(
                        patient.primaryOwner[0].mobile ||
                            patient.primaryOwner[0].work ||
                            patient.primaryOwner[0].home
                    );

                    this.client_encoded_id = patient.primaryOwner[0].encoded_id;
                }
            }
        },
        async syncRecord() {
            const params = {
                business_id: this.$root.setting.business_id,
                client_id: this.data.client_id,
                patient_id: this.data.patient_id,
            };

            await Records.syncRecords(params);
        },
        async getSyncStatus() {
            let response = await Records.getSyncStatus();

            if (response.code == 200) {
                if (response.resource?.is_pause == 0) {
                    this.vetsourceSynced = true;
                    localStorage.setItem("vetsource_synced", true);
                } else if (response.resource?.is_pause == 1) {
                    this.vetsourceSynced = false;
                    localStorage.setItem("vetsource_synced", false);
                }
            }
        }
    }
}